import designSystemDefaults from "../design-system";
/**
 * Safely retrieves the value from a key of the DesignSystem.
 */
export function getDesignSystemValue(key) {
    return (designSystem) => {
        return designSystem && designSystem[key] !== undefined
            ? designSystem[key]
            : designSystemDefaults[key];
    };
}
/**
 * Retrieve the backgroundColor when invoked with a DesignSystem
 */
export const backgroundColor = getDesignSystemValue("backgroundColor");
/**
 * Retrieve the accentBaseColor when invoked with a DesignSystem
 */
export const accentBaseColor = getDesignSystemValue("accentBaseColor");
/**
 * Retrieve the cornerRadius when invoked with a DesignSystem
 */
export const cornerRadius = getDesignSystemValue("cornerRadius");
/**
 * Retrieve the elevatedCornerRadius when invoked with a DesignSystem
 */
export const elevatedCornerRadius = getDesignSystemValue("elevatedCornerRadius");
/**
 * Retrieve the neutral palette from the design system
 */
export const neutralPalette = getDesignSystemValue("neutralPalette");
/**
 * Retrieve the accent palette from the design system
 */
export const accentPalette = getDesignSystemValue("accentPalette");
/**
 * Retrieve the contrast from the design system
 */
export const contrast = getDesignSystemValue("contrast");
/**
 * Retrieve the designUnit from the design system
 */
export const designUnit = getDesignSystemValue("designUnit");
/**
 * Retrieve the baseHeightMultiplier from the design system
 */
export const baseHeightMultiplier = getDesignSystemValue("baseHeightMultiplier");
/**
 * Retrieve the baseHorizontalSpacingMultiplier from the design system
 */
export const baseHorizontalSpacingMultiplier = getDesignSystemValue("baseHorizontalSpacingMultiplier");
/**
 * Retrieve the direction from the design system
 */
export const direction = getDesignSystemValue("direction");
/**
 * Retrieve the outlineWidth from the design system
 */
export const outlineWidth = getDesignSystemValue("outlineWidth");
/**
 * Retrieve the focusOutlineWidth from the design system
 */
export const focusOutlineWidth = getDesignSystemValue("focusOutlineWidth");
/**
 * Retrieve the direction from the design system
 */
export const disabledOpacity = getDesignSystemValue("disabledOpacity");
export const accentFillRestDelta = getDesignSystemValue("accentFillRestDelta");
export const accentFillHoverDelta = getDesignSystemValue("accentFillHoverDelta");
export const accentFillActiveDelta = getDesignSystemValue("accentFillActiveDelta");
export const accentFillFocusDelta = getDesignSystemValue("accentFillFocusDelta");
export const accentFillSelectedDelta = getDesignSystemValue("accentFillSelectedDelta");
export const accentForegroundRestDelta = getDesignSystemValue("accentForegroundRestDelta");
export const accentForegroundHoverDelta = getDesignSystemValue("accentForegroundHoverDelta");
export const accentForegroundActiveDelta = getDesignSystemValue("accentForegroundActiveDelta");
export const accentForegroundFocusDelta = getDesignSystemValue("accentForegroundFocusDelta");
export const neutralFillRestDelta = getDesignSystemValue("neutralFillRestDelta");
export const neutralFillHoverDelta = getDesignSystemValue("neutralFillHoverDelta");
export const neutralFillActiveDelta = getDesignSystemValue("neutralFillActiveDelta");
export const neutralFillFocusDelta = getDesignSystemValue("neutralFillFocusDelta");
export const neutralFillSelectedDelta = getDesignSystemValue("neutralFillSelectedDelta");
export const neutralFillInputRestDelta = getDesignSystemValue("neutralFillInputRestDelta");
export const neutralFillInputHoverDelta = getDesignSystemValue("neutralFillInputHoverDelta");
export const neutralFillInputActiveDelta = getDesignSystemValue("neutralFillInputActiveDelta");
export const neutralFillInputFocusDelta = getDesignSystemValue("neutralFillInputFocusDelta");
export const neutralFillInputSelectedDelta = getDesignSystemValue("neutralFillInputSelectedDelta");
export const neutralFillStealthRestDelta = getDesignSystemValue("neutralFillStealthRestDelta");
export const neutralFillStealthHoverDelta = getDesignSystemValue("neutralFillStealthHoverDelta");
export const neutralFillStealthActiveDelta = getDesignSystemValue("neutralFillStealthActiveDelta");
export const neutralFillStealthFocusDelta = getDesignSystemValue("neutralFillStealthFocusDelta");
export const neutralFillStealthSelectedDelta = getDesignSystemValue("neutralFillStealthSelectedDelta");
export const neutralFillToggleHoverDelta = getDesignSystemValue("neutralFillToggleHoverDelta");
export const neutralFillToggleActiveDelta = getDesignSystemValue("neutralFillToggleActiveDelta");
export const neutralFillToggleFocusDelta = getDesignSystemValue("neutralFillToggleFocusDelta");
export const baseLayerLuminance = getDesignSystemValue("baseLayerLuminance");
export const neutralFillCardDelta = getDesignSystemValue("neutralFillCardDelta");
/**
 * @deprecated Neutral foreground is now based on contrast and this is no longer used.
 */
export const neutralForegroundDarkIndex = getDesignSystemValue("neutralForegroundDarkIndex");
/**
 * @deprecated Neutral foreground is now based on contrast and this is no longer used.
 */
export const neutralForegroundLightIndex = getDesignSystemValue("neutralForegroundLightIndex");
export const neutralForegroundHoverDelta = getDesignSystemValue("neutralForegroundHoverDelta");
export const neutralForegroundActiveDelta = getDesignSystemValue("neutralForegroundActiveDelta");
export const neutralForegroundFocusDelta = getDesignSystemValue("neutralForegroundFocusDelta");
export const neutralDividerRestDelta = getDesignSystemValue("neutralDividerRestDelta");
export const neutralOutlineRestDelta = getDesignSystemValue("neutralOutlineRestDelta");
export const neutralOutlineHoverDelta = getDesignSystemValue("neutralOutlineHoverDelta");
export const neutralOutlineActiveDelta = getDesignSystemValue("neutralOutlineActiveDelta");
export const getFontWeight = getDesignSystemValue("fontWeight");
export const neutralOutlineFocusDelta = getDesignSystemValue("neutralOutlineFocusDelta");
